import script from "./DownloadView.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadView.vue?vue&type=script&setup=true&lang=js"

import "./DownloadView.vue?vue&type=style&index=0&id=2d660639&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d660639"]])

export default __exports__